import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const RedemptionOrdersRoutes: Routes = [
  {
    path: "redemption-orders",
    loadComponent: () =>
      import("./redemption-orders/redemption-orders.component").then(
        (m) => m.RedemptionOrdersComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./redemption-orders-list/redemption-orders-list.component").then(
            (m) => m.RedemptionOrdersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./redemption-orders-form/redemption-orders-form.component").then(
            (m) => m.RedemptionOrdersFormComponent,
          ),
      },
      {
        path: "view/:identifier",
        loadComponent: () =>
          import("./redemption-orders-form/redemption-orders-form.component").then(
            (m) => m.RedemptionOrdersFormComponent,
          ),
      },
    ],
  },
];
